import * as type from './notificationMessageActionTypes';

// Notification Messages
export const getNotificationsMessages = (userId) => ({
  type: type.GET_NOTIFICATION_MESSAGES,
  userId,
});

export const setNotificationsMessagesUnread = (notifications) => ({
  type: type.SET_NOTIFICATIONS_MESSAGE_UNREAD,
  notifications,
});

export const setNotificationsMessagesSeen = (notifications) => ({
  type: type.SET_NOTIFICATIONS_MESSAGE_SEEN,
  notifications,
});

export const notificationsMessagesSeenAction = (notifications) => ({
  type: type.NOTIFICATIONS_MESSAGE_SEEN,
  notifications,
});

export const loadNotifications = (value) => ({
  type: type.LOAD_NOTIFICATIONS,
  value,
});
